import { UPDATE_BLOG_STATE } from "../actionTypes"

const initialState = ''

const BlogUpdate = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_BLOG_STATE:
            return action.payload

        default: return state
    }
}

export default BlogUpdate;